import React from "react";
import Reveal from "@/components/Reveal";
import { AlertTriangle, IndianRupee, PenLine, Users, Compass } from "lucide-react";

const points = [
 {
 icon: IndianRupee,
 title: "Chasing the lowest price",
 text: (
 <>
 Founders pick <strong className="font-bold text-[#0F1115]">₹999/- or ₹9,999/-</strong> packages, then realise structure, MOA, and compliance were wrong for their business.
 </>
 ),
 },
 { icon: Compass, title: "No clarity on structure", text: "PVT. LTD., LLP or OPC the choice determines your tax, cap-table and future fundraising. Most factories skip this conversation." },
 { icon: PenLine, title: "Paperwork over guidance", text: "Filing is a small part of starting up. You also need launch readiness, presence and compliance planning." },
 { icon: Users, title: "No one to call after", text: "Once payment is done, you're on your own with jargon. Not with a founder-led partner." },
];

export const ProblemSection = () => (
 <section className="bg-white" data-testid="problem-section">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
 <Reveal>
 <div className="max-w-2xl">
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 <AlertTriangle className="inline mr-2 text-[#FDD805]" size={14} />
 The problem
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
 Why First-Time Founders often make the <span className="hl-yellow">wrong start</span>.
 </h2>
 <p className="mt-5 text-[16px] md:text-[17px] text-[#1C1F26] max-w-xl leading-relaxed">
 Most founders choose a service provider only on price. But when you're
 starting a business for the first time, the real need is not just
 registration you need clarity, the right guidance and the right
 next steps.
 </p>
 </div>
 </Reveal>

 <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
 {points.map((p, i) => {
 const Icon = p.icon;
 return (
 <Reveal key={p.title} delay={i * 90}>
 <div className="h-full border border-[#EAEAEA] rounded-2xl p-6 md:p-7 bg-white flex flex-col items-center text-center hover:border-[#FDD805] transition-colors">
 <div className="w-12 h-12 rounded-full bg-[#FFF9E6] flex items-center justify-center">
 <Icon size={20} className="text-[#0F1115]" />
 </div>
 <h3 className="mt-5 font-display text-[19px] font-bold text-[#0F1115]">
 {p.title}
 </h3>
 <div className="mt-2 text-[14.5px] leading-relaxed text-[#1C1F26]">
 {p.text}
 </div>
 </div>
 </Reveal>
 );
 })}
 </div>
 </div>
 </section>
);

export default ProblemSection;
